<div class="container single-view" id="add-retailer-type">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" routerLink="/retailer-types/" class="inline-flex items-center text-base link link-icon left-arrow">{{
        'RETAILER_TYPES.BTN_BACK_TO_RETAILER_TYPE' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="add-retailertype-title" class="section-title">{{ 'RETAILER_TYPE_CREATE.TITLE' | translate }}</h1>
          <p data-testid="add-retailertype-subtitle" class="section-subtitle mt-1 text-base">{{ 'RETAILER_TYPE_CREATE.SUBTITLE' | translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <form class="mt-0" [formGroup]="retailerTypeForm" data-testid="add-retailertype-form">
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 data-testid="add-retailertype-details-title" class="border-b pb-3">{{ 'RETAILER_TYPE_CREATE.RETAILER_TYPE_DETAILS' | translate }}</h2>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-retailertype-field-name" class="block text-sm" for="name">{{ 'RETAILER_TYPE_CREATE.NAME' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-retailertype-name-input" type="text" id="name" formControlName="name" autocomplete="off">
                  @if (retailerTypeForm.get('name')?.invalid && retailerTypeForm.get('name')?.touched) {
                    <small data-testid="name-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-retailertype-field-code" class="block text-sm" for="code">{{ 'RETAILER_TYPE_CREATE.CODE' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-retailertype-code-input" type="text" id="code" formControlName="code" autocomplete="off">
                  @if (retailerTypeForm.get('code')?.invalid && retailerTypeForm.get('code')?.touched) {
                    <small data-testid="code-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <span data-testid="add-retailertype-field-hasParent" class="block text-sm mb-3" for="hasParentRetailerType">{{ 'RETAILER_TYPE_CREATE.HAS_PARENT' | translate }}</span>
                  <label data-testid="add-retailertype-has-parent-yes-label" class="inline-flex mr-6">
                    <p-radioButton data-testid="add-retailertype-has-parent-yes" name="hasParentRetailerType" value="true" formControlName="hasParentRetailerType" inputId="yes" />
                    <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                  </label>
                  <label data-testid="add-retailertype-has-parent-no-label" class="inline-flex mr-2">
                    <p-radioButton data-testid="add-retailertype-has-parent-no" name="hasParentRetailerType" value="false" formControlName="hasParentRetailerType" inputId="no" />
                    <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                  </label>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3"
                  [ngClass]="{'disabled': retailerTypeForm.get('hasParentRetailerType')?.value == 'false'}">
                  <label data-testid="add-retailer-field-parentretailertype" class="block text-sm" for="retailerTypeId">{{ 'RETAILER_TYPE_CREATE.PARENT_RETAILER_TYPE' | translate }}</label>
                  <app-custom-dropdown
                    data-testid="parentretailertype"
                    [placeholder]="'RETAILER_TYPE_CREATE.SELECT_PARENT_PLACEHOLDER' | translate"
                    optionLabel="text"
                    optionValue="id"
                    [isMultiselect]="false"
                    [showSelectionChips]="true"
                    [showClear]="true"
                    [searchMode]="'remote'"
                    [pageSize]="comboData.rowsPerPageOption || 5"
                    [totalCount]="comboData.totalRecords"
                    [totalPages]="getComboTotalPages()"
                    [options]="comboData.list"
                    formControlName="retailerTypeId"
                    (onLazyLoad)="onLazyLoadComboData($event)">
                  </app-custom-dropdown>
                  @if (retailerTypeForm.errors?.['requiredRetailerType'] && isRetailerTypeRequired()) {
                    <small data-testid="parent-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
              </div>
              <div class="row">
                <div class="col-12 mt-6 mb-4 pt-8 border-t">
                  <div class="flex items-center justify-end gap-3">
                    <button data-testid="add-retailertype-create-retailertype-button" class="btn primary-btn" [disabled]="retailerTypeForm.invalid"
                      (click)="submitForm()">{{
                    'RETAILER_TYPE_CREATE.BTN_CREATE_RETAILER_TYPE' | translate }}</button>
                  </div>
                </div>
              </div>
            </form>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
